import React from "react";

export const NavContext = React.createContext(null);